var render = function (_h,_vm) {var _c=_vm._c;return _c('b-row',{class:{ 'mb-3': !_vm.props.noMarginBottom }},[_c('b-col',{staticClass:"py-2 bg-primary text-white font-weight-bold"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }